<template>

</template>

<script>
  // const urlBase = 'http://127.0.0.1:8080';    //本地测试环境域名链接
  // const apiBase = 'http://192.168.0.105:20044';   //本地测试环境API链接
  // const apiBase = 'http://127.0.0.1:20044';   //本地测试环境API链接
  // const urlBase = 'http://law.exqoo.com';    //测试环境域名链接
  // const apiBase = 'http://39.107.106.251:20044';   //测试环境API链接

  const urlBase = 'http://tax.fajiankeji.com';    //正式环境域名链接
  const apiBase = 'http://tax.fajiankeji.com:20044';   //正式环境API链接


  const consoleBase = 'http://tax.fajiankeji.com:20045';  //正式环境控制台域名IP

  const reportSaveDays = 7;//保存报告答题记录的时间上限（天）

  export default {
    urlBase,
    apiBase,
    consoleBase,
    reportSaveDays
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Globle.vue